import React from 'react'
import AdminNavbar from "../Navbars/AdminNavbar";
import AdminSidebar from '../Sidebar/AdminSidebar';
import { SuperAdminApis } from '../../apis/superAdminApi';
import { AxiosResponse } from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import FoodRateTable from './FoodRateTable';
import StandardRateTable from './StandardRateTable';

function ManageRates() {
  const [tabNo, setTabNo] = React.useState<string>('1');
  const [lgaRateTab, setLgaRateTab] = React.useState<string>('domestic'); // For LGA sub-tabs

  // New rate data
  const [domesticRates, setDomesticRates] = React.useState<any>([]);
  const [bulkRates, setBulkRates] = React.useState<any>([]);
  const [bulkExtraRates, setBulkExtraRates] = React.useState<any>([]);
  const [expressRates, setExpressRates] = React.useState<any>([]);
  const [exportRates, setExportRates] = React.useState<any>([]);

  // NEW: LGA Rate data
  const [lgaDomesticRates, setLgaDomesticRates] = React.useState<any>([]);
  const [lgaBulkRates, setLgaBulkRates] = React.useState<any>([]);
  const [selectedStateForLga, setSelectedStateForLga] = React.useState<string>('');

  // Old system data (for state selection)
  const [stateTo, setStateTo] = React.useState<any>([]);

  // Available states for filtering
  const availableStates = [
    'Lagos', 'Abuja', 'Abia', 'Adamawa', 'Akwa Ibom', 'Anambra', 'Bauchi', 'Bayelsa',
    'Benue', 'Borno', 'Cross River', 'Delta', 'Ebonyi', 'Edo', 'Ekiti', 'Enugu',
    'Gombe', 'Imo', 'Jigawa', 'Kaduna', 'Kano', 'Katsina', 'Kebbi', 'Kogi',
    'Kwara', 'Nassarawa', 'Niger', 'Ogun', 'Ondo', 'Osun', 'Oyo', 'Plateau',
    'Rivers', 'Sokoto', 'Taraba', 'Yobe', 'Zamfara', 'FCT'
  ];

  // Zone information
  const zoneInfo = [
    {
      zone: 'Zone 1',
      zoneNumber: 1,
      description: 'Lagos',
      states: ['Lagos']
    },
    {
      zone: 'Zone 2',
      zoneNumber: 2,
      description: 'South West (excluding Lagos)',
      states: ['Ekiti', 'Ogun', 'Ondo', 'Osun', 'Oyo']
    },
    {
      zone: 'Zone 3',
      zoneNumber: 3,
      description: 'South South + FCT + Kwara',
      states: ['Abuja', 'FCT', 'Kwara', 'Abia', 'Delta', 'Anambra', 'Edo', 'Enugu', 'Imo', 'Rivers']
    },
    {
      zone: 'Zone 4',
      zoneNumber: 4,
      description: 'North + Remaining South',
      states: ['Adamawa', 'Akwa Ibom', 'Bauchi', 'Bayelsa', 'Benue', 'Borno', 'Cross River', 'Ebonyi', 'Gombe', 'Jigawa', 'Kaduna', 'Kano', 'Katsina', 'Kebbi', 'Kogi', 'Nassarawa', 'Niger', 'Plateau', 'Sokoto', 'Taraba', 'Yobe', 'Zamfara']
    }
  ];

  React.useEffect(() => {
    loadAllRates();
  }, []);

  React.useEffect(() => {
    if (tabNo === '7') {
      loadLgaRates();
    }
  }, [tabNo, selectedStateForLga, lgaRateTab]);

  const loadAllRates = () => {
    SuperAdminApis.getAllDomesticRates().then((response: AxiosResponse<any>) => {
      if (response?.data?.status) {
        setDomesticRates(response?.data?.data);
      }
    }).catch(err => console.error('Error loading domestic rates:', err));

    SuperAdminApis.getAllBulkRates().then((response: AxiosResponse<any>) => {
      if (response?.data?.status) {
        setBulkRates(response?.data?.data);
      }
    }).catch(err => console.error('Error loading bulk rates:', err));

    SuperAdminApis.getAllBulkExtraRates().then((response: AxiosResponse<any>) => {
      if (response?.data?.status) {
        setBulkExtraRates(response?.data?.data);
      }
    }).catch(err => console.error('Error loading bulk extra rates:', err));

    SuperAdminApis.getAllExpressRates().then((response: AxiosResponse<any>) => {
      if (response?.data?.status) {
        setExpressRates(response?.data?.data);
      }
    }).catch(err => console.error('Error loading express rates:', err));

    SuperAdminApis.getAllExportRates().then((response: AxiosResponse<any>) => {
      if (response?.data?.status) {
        setExportRates(response?.data?.data);
      }
    }).catch(err => console.error('Error loading export rates:', err));
  };

  const loadLgaRates = () => {
    // Load LGA Domestic Rates
    SuperAdminApis.getLgaDomesticRates(selectedStateForLga || '')
      .then((response: AxiosResponse<any>) => {
        if (response?.data?.status) {
          setLgaDomesticRates(response?.data?.data || []);
        }
      })
      .catch(err => console.error('Error loading LGA domestic rates:', err));

    // Load LGA Bulk Rates
    SuperAdminApis.getLgaBulkRates(selectedStateForLga || '')
      .then((response: AxiosResponse<any>) => {
        if (response?.data?.status) {
          setLgaBulkRates(response?.data?.data || []);
        }
      })
      .catch(err => console.error('Error loading LGA bulk rates:', err));
  };

  // Upload handlers for standard rates
  const uploadDomesticRates = (e: any) => {
    if (e.target.files && e.target.files[0]) {
      e.preventDefault();
      const formData = new FormData();
      formData.append('file', e.target.files[0]);

      SuperAdminApis.uploadDomesticRates(formData).then((response: AxiosResponse<any>) => {
        if (response?.data?.status) {
          toast.success('Domestic rates uploaded successfully');
          loadAllRates();
        } else {
          toast.warn(response?.data?.message || 'Upload failed');
        }
      }).catch(() => {
        toast.error('Wrong file format or upload error');
      });
    }
  };

  const uploadBulkRates = (e: any) => {
    if (e.target.files && e.target.files[0]) {
      e.preventDefault();
      const formData = new FormData();
      formData.append('file', e.target.files[0]);

      SuperAdminApis.uploadBulkRates(formData).then((response: AxiosResponse<any>) => {
        if (response?.data?.status) {
          toast.success('Bulk rates uploaded successfully');
          loadAllRates();
        } else {
          toast.warn(response?.data?.message || 'Upload failed');
        }
      }).catch(() => {
        toast.error('Wrong file format or upload error');
      });
    }
  };

  const uploadBulkExtraRates = (e: any) => {
    if (e.target.files && e.target.files[0]) {
      e.preventDefault();
      const formData = new FormData();
      formData.append('file', e.target.files[0]);

      SuperAdminApis.uploadBulkExtraRates(formData).then((response: AxiosResponse<any>) => {
        if (response?.data?.status) {
          toast.success('Bulk extra rates uploaded successfully');
          loadAllRates();
        } else {
          toast.warn(response?.data?.message || 'Upload failed');
        }
      }).catch(() => {
        toast.error('Wrong file format or upload error');
      });
    }
  };

  const uploadExpressRates = (e: any) => {
    if (e.target.files && e.target.files[0]) {
      e.preventDefault();
      const formData = new FormData();
      formData.append('file', e.target.files[0]);

      SuperAdminApis.uploadExpressRates(formData).then((response: AxiosResponse<any>) => {
        if (response?.data?.status) {
          toast.success('Express rates uploaded successfully');
          loadAllRates();
        } else {
          toast.warn(response?.data?.message || 'Upload failed');
        }
      }).catch(() => {
        toast.error('Wrong file format or upload error');
      });
    }
  };

  const uploadExportRates = (e: any) => {
    if (e.target.files && e.target.files[0]) {
      e.preventDefault();
      const formData = new FormData();
      formData.append('file', e.target.files[0]);

      SuperAdminApis.uploadExportRates(formData).then((response: AxiosResponse<any>) => {
        if (response?.data?.status) {
          toast.success('Export rates uploaded successfully');
          loadAllRates();
        } else {
          toast.warn(response?.data?.message || 'Upload failed');
        }
      }).catch(() => {
        toast.error('Wrong file format or upload error');
      });
    }
  };

  // NEW: Upload handlers for LGA rates
  const uploadLgaDomesticRates = (e: any) => {
    if (e.target.files && e.target.files[0]) {
      e.preventDefault();
      const formData = new FormData();
      formData.append('file', e.target.files[0]);

      SuperAdminApis.uploadLgaDomesticRates(formData)
        .then((response: AxiosResponse<any>) => {
          if (response?.data?.status) {
            toast.success('LGA domestic rates uploaded successfully');
            loadLgaRates();
          } else {
            toast.warn(response?.data?.message || 'Upload failed');
          }
        })
        .catch(() => {
          toast.error('Wrong file format or upload error');
        });
    }
  };

  const uploadLgaBulkRates = (e: any) => {
    if (e.target.files && e.target.files[0]) {
      e.preventDefault();
      const formData = new FormData();
      formData.append('file', e.target.files[0]);

      SuperAdminApis.uploadLgaBulkRates(formData)
        .then((response: AxiosResponse<any>) => {
          if (response?.data?.status) {
            toast.success('LGA bulk rates uploaded successfully');
            loadLgaRates();
          } else {
            toast.warn(response?.data?.message || 'Upload failed');
          }
        })
        .catch(() => {
          toast.error('Wrong file format or upload error');
        });
    }
  };

  const downloadTemplate = async (type: string) => {
    try {
      let response;
      let filename = '';

      switch (type) {
        case 'domestic':
          response = await SuperAdminApis.downloadDomesticRateTemplate();
          filename = 'domestic_rate_template.xlsx';
          break;
        case 'bulk':
          response = await SuperAdminApis.downloadBulkRateTemplate();
          filename = 'bulk_rate_template.xlsx';
          break;
        case 'bulk-extra':
          response = await SuperAdminApis.downloadBulkExtraRateTemplate();
          filename = 'bulk_extra_rate_template.xlsx';
          break;
        case 'express':
          response = await SuperAdminApis.downloadExpressRateTemplate();
          filename = 'express_rate_template.xlsx';
          break;
        case 'export':
          response = await SuperAdminApis.downloadExportRateTemplate();
          filename = 'export_rate_template.xlsx';
          break;
        case 'lga-domestic':
          response = await SuperAdminApis.downloadLgaDomesticRateTemplate();
          filename = 'lga_domestic_rate_template.xlsx';
          break;
        case 'lga-bulk':
          response = await SuperAdminApis.downloadLgaBulkRateTemplate();
          filename = 'lga_bulk_rate_template.xlsx';
          break;
        default:
          return;
      }

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();

      toast.success('Template downloaded successfully');
    } catch (error) {
      toast.error('Failed to download template');
      console.error('Download error:', error);
    }
  };

  return (
    <>
      <AdminSidebar title="Rate Management" />
      <div className="relative md:ml-64 bg-[#FAFAFA]">
        <AdminNavbar title="Rate Management" />

        {/* Tab Navigation */}
        <div className='flex justify-start gap-2 m-5 flex-wrap'>
          <button onClick={() => setTabNo('0')} className={`px-4 py-2 rounded-md font-medium ${tabNo === '0' ? 'bg-[#E04343] text-white' : 'bg-gray-200 text-gray-700'}`}>
            View Zones & States
          </button>
          <button onClick={() => setTabNo('1')} className={`px-4 py-2 rounded-md font-medium ${tabNo === '1' ? 'bg-[#E04343] text-white' : 'bg-gray-200 text-gray-700'}`}>
            Domestic Rates
          </button>
          <button onClick={() => setTabNo('2')} className={`px-4 py-2 rounded-md font-medium ${tabNo === '2' ? 'bg-[#E04343] text-white' : 'bg-gray-200 text-gray-700'}`}>
            Bulk Rates
          </button>
          <button onClick={() => setTabNo('3')} className={`px-4 py-2 rounded-md font-medium ${tabNo === '3' ? 'bg-[#E04343] text-white' : 'bg-gray-200 text-gray-700'}`}>
            Bulk Extra Rates
          </button>
          <button onClick={() => setTabNo('4')} className={`px-4 py-2 rounded-md font-medium ${tabNo === '4' ? 'bg-[#E04343] text-white' : 'bg-gray-200 text-gray-700'}`}>
            Express Rates
          </button>
          <button onClick={() => setTabNo('5')} className={`px-4 py-2 rounded-md font-medium ${tabNo === '5' ? 'bg-[#E04343] text-white' : 'bg-gray-200 text-gray-700'}`}>
            Export Rates
          </button>
          <button onClick={() => setTabNo('7')} className={`px-4 py-2 rounded-md font-medium ${tabNo === '7' ? 'bg-[#E04343] text-white' : 'bg-gray-200 text-gray-700'}`}>
            LGA Rates
          </button>
          <button onClick={() => setTabNo('8')} className={`px-4 py-2 rounded-md font-medium ${tabNo === '8' ? 'bg-[#E04343] text-white' : 'bg-gray-200 text-gray-700'}`}>
            Food Rates
          </button>
        </div>

        {/* TAB 8: Food items tariff — the standard one, used by cash customers and by
            any credit customer who has not negotiated their own. */}
        {tabNo === '8' && (
          <div className='lg:px-10 pb-6 px-6 bg-[#FAFAFA] min-h-screen'>
            <FoodRateTable />
          </div>
        )}

        {/* TAB 0: View Zones & States */}
        {tabNo === '0' && (
          <div className='lg:px-10 pb-6 px-6 bg-[#FAFAFA] min-h-screen'>
            <h3 className='text-[18px] text-[#1C1C1C] font-semibold mb-4'>Zone Configuration</h3>

            <div className='bg-blue-50 border-l-4 border-blue-500 p-4 mb-6'>
              <p className='font-semibold text-blue-900'>How Zones Work:</p>
              <p className='text-sm text-blue-800 mt-2'>
                Zones determine the BASE RATE for domestic and bulk shipments. When calculating rates:
              </p>
              <ul className='text-sm text-blue-800 mt-2 ml-4 list-disc'>
                <li>System looks at the DESTINATION STATE</li>
                <li>Finds which ZONE that state belongs to</li>
                <li>Uses the rate for that zone (Zone 1-4)</li>
                <li>LGA charges (if any) are ADDED to the zone rate</li>
              </ul>
            </div>

            <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
              {zoneInfo.map((zone) => (
                <div key={zone.zoneNumber} className='bg-white rounded-lg shadow p-4'>
                  <div className='flex items-center justify-between mb-3'>
                    <h4 className='text-lg font-semibold text-[#E04343]'>{zone.zone}</h4>
                    <span className='bg-[#E04343] text-white px-3 py-1 rounded-full text-sm'>
                      {zone.states.length} States
                    </span>
                  </div>
                  <p className='text-sm text-gray-600 mb-3'>{zone.description}</p>
                  <div className='border-t pt-3'>
                    <p className='text-xs font-semibold text-gray-700 mb-2'>States in this zone:</p>
                    <div className='flex flex-wrap gap-2'>
                      {zone.states.map((state) => (
                        <span key={state} className='bg-gray-100 px-2 py-1 rounded text-xs'>
                          {state}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* TAB 1: Domestic Rates */}
        {tabNo === '1' && (
          <div className='lg:px-10 pb-6 px-6 bg-[#FAFAFA] min-h-screen'>
            <div className='flex justify-between items-center mb-4'>
              <h3 className='text-[18px] text-[#1C1C1C] font-semibold'>Domestic Rates (0.5kg - 10kg)</h3>
              <div className='flex gap-2'>
                <button onClick={() => downloadTemplate('domestic')} className='bg-blue-500 text-white px-4 py-2 rounded-md text-sm'>
                  Download Template
                </button>
                <label className="bg-[#E04343] text-white px-4 py-2 rounded-md cursor-pointer text-sm">
                  Upload Excel
                  <input type="file" accept=".xlsx,.xls" onChange={uploadDomesticRates} className="hidden" />
                </label>
              </div>
            </div>

            <StandardRateTable
              type="domestic"
              rows={domesticRates || []}
              onChanged={loadAllRates}
            />
          </div>
        )}

        {/* TAB 2: Bulk Rates */}
        {tabNo === '2' && (
          <div className='lg:px-10 pb-6 px-6 bg-[#FAFAFA] min-h-screen'>
            <div className='flex justify-between items-center mb-4'>
              <h3 className='text-[18px] text-[#1C1C1C] font-semibold'>Bulk Rates (20.5kg - 50kg)</h3>
              <div className='flex gap-2'>
                <button onClick={() => downloadTemplate('bulk')} className='bg-blue-500 text-white px-4 py-2 rounded-md text-sm'>
                  Download Template
                </button>
                <label className="bg-[#E04343] text-white px-4 py-2 rounded-md cursor-pointer text-sm">
                  Upload Excel
                  <input type="file" accept=".xlsx,.xls" onChange={uploadBulkRates} className="hidden" />
                </label>
              </div>
            </div>

            <StandardRateTable
              type="bulk"
              rows={bulkRates || []}
              onChanged={loadAllRates}
            />
          </div>
        )}

        {/* TAB 3: Bulk Extra Rates */}
        {tabNo === '3' && (
          <div className='lg:px-10 pb-6 px-6 bg-[#FAFAFA] min-h-screen'>
            <div className='flex justify-between items-center mb-4'>
              <h3 className='text-[18px] text-[#1C1C1C] font-semibold'>Bulk Extra Rates (51kg - 500kg)</h3>
              <div className='flex gap-2'>
                <button onClick={() => downloadTemplate('bulk-extra')} className='bg-blue-500 text-white px-4 py-2 rounded-md text-sm'>
                  Download Template
                </button>
                <label className="bg-[#E04343] text-white px-4 py-2 rounded-md cursor-pointer text-sm">
                  Upload Excel
                  <input type="file" accept=".xlsx,.xls" onChange={uploadBulkExtraRates} className="hidden" />
                </label>
              </div>
            </div>

            <StandardRateTable
              type="bulk_extra"
              rows={bulkExtraRates || []}
              onChanged={loadAllRates}
            />
          </div>
        )}

        {/* TAB 4: Express Rates */}
        {tabNo === '4' && (
          <div className='lg:px-10 pb-6 px-6 bg-[#FAFAFA] min-h-screen'>
            <div className='flex justify-between items-center mb-4'>
              <h3 className='text-[18px] text-[#1C1C1C] font-semibold'>Express Rates</h3>
              <div className='flex gap-2'>
                <button onClick={() => downloadTemplate('express')} className='bg-blue-500 text-white px-4 py-2 rounded-md text-sm'>
                  Download Template
                </button>
                <label className="bg-[#E04343] text-white px-4 py-2 rounded-md cursor-pointer text-sm">
                  Upload Excel
                  <input type="file" accept=".xlsx,.xls" onChange={uploadExpressRates} className="hidden" />
                </label>
              </div>
            </div>

            <StandardRateTable
              type="express"
              rows={expressRates || []}
              onChanged={loadAllRates}
            />
          </div>
        )}

        {/* TAB 5: Export Rates */}
        {tabNo === '5' && (
          <div className='lg:px-10 pb-6 px-6 bg-[#FAFAFA] min-h-screen'>
            <div className='flex justify-between items-center mb-4'>
              <h3 className='text-[18px] text-[#1C1C1C] font-semibold'>Export Rates (International)</h3>
              <div className='flex gap-2'>
                <button onClick={() => downloadTemplate('export')} className='bg-blue-500 text-white px-4 py-2 rounded-md text-sm'>
                  Download Template
                </button>
                <label className="bg-[#E04343] text-white px-4 py-2 rounded-md cursor-pointer text-sm">
                  Upload Excel
                  <input type="file" accept=".xlsx,.xls" onChange={uploadExportRates} className="hidden" />
                </label>
              </div>
            </div>

            <StandardRateTable
              type="export"
              rows={exportRates || []}
              onChanged={loadAllRates}
            />
          </div>
        )}

        {/* TAB 7: NEW LGA Rates Management */}
        {tabNo === '7' && (
          <div className='lg:px-10 pb-6 px-6 bg-[#FAFAFA] min-h-screen'>
            <h3 className='text-[18px] text-[#1C1C1C] font-semibold mb-4'>LGA Rates (Location-Based Additional Charges)</h3>

            <div className='bg-yellow-50 border-l-4 border-yellow-500 p-4 mb-6'>
              <p className='font-semibold text-yellow-900'>How LGA Rates Work:</p>
              <p className='text-sm text-yellow-800 mt-2'>
                LGA rates are ADDITIONAL costs that are ADDED to the base zone rate. They include:
              </p>
              <ul className='text-sm text-yellow-800 mt-2 ml-4 list-disc'>
                <li><strong>Base Weight:</strong> Starting weight of the range (e.g., 0.5kg)</li>
                <li><strong>Upper Weight:</strong> Maximum weight of the range (e.g., 10kg)</li>
                <li><strong>Onforwarding Value:</strong> Fixed cost for shipments within the weight range</li>
                <li><strong>Add 1kg:</strong> Additional cost per kg if weight exceeds the upper limit</li>
              </ul>
              <p className='text-sm text-yellow-800 mt-2'>
                <strong>Example:</strong> If base rate is ₦5,000, onforwarding value is ₦2,000, and weight is 8kg in range (0.5-10kg),
                total LGA charge = ₦2,000 + (0 × add1kg) = ₦2,000. Final cost = ₦5,000 + ₦2,000 = ₦7,000 + VAT
              </p>
            </div>

            {/* LGA Rate Type Tabs */}
            <div className='flex gap-2 mb-4'>
              <button
                onClick={() => setLgaRateTab('domestic')}
                className={`px-4 py-2 rounded-md font-medium ${lgaRateTab === 'domestic' ? 'bg-green-600 text-white' : 'bg-gray-200 text-gray-700'}`}
              >
                Domestic LGA Rates (0.5-10kg)
              </button>
              <button
                onClick={() => setLgaRateTab('bulk')}
                className={`px-4 py-2 rounded-md font-medium ${lgaRateTab === 'bulk' ? 'bg-green-600 text-white' : 'bg-gray-200 text-gray-700'}`}
              >
                Bulk LGA Rates (20-999kg)
              </button>
            </div>

            {/* State Filter */}
            <div className='mb-6 flex gap-4 items-center'>
              <div className='flex-1 max-w-md'>
                <label className='block text-sm font-medium mb-2'>Filter by State (Optional)</label>
                <select
                  value={selectedStateForLga}
                  onChange={(e) => setSelectedStateForLga(e.target.value)}
                  className='w-full px-4 py-2 border rounded-md'
                >
                  <option value="">-- All States --</option>
                  {availableStates.map((state) => (
                    <option key={state} value={state}>
                      {state}
                    </option>
                  ))}
                </select>
              </div>
              <div className='flex gap-2 items-end'>
                <button
                  onClick={() => downloadTemplate(lgaRateTab === 'domestic' ? 'lga-domestic' : 'lga-bulk')}
                  className='bg-blue-500 text-white px-4 py-2 rounded-md text-sm'
                >
                  Download Template
                </button>
                <label className="bg-[#E04343] text-white px-4 py-2 rounded-md cursor-pointer text-sm">
                  Upload Excel
                  <input
                    type="file"
                    accept=".xlsx,.xls"
                    onChange={lgaRateTab === 'domestic' ? uploadLgaDomesticRates : uploadLgaBulkRates}
                    className="hidden"
                  />
                </label>
              </div>
            </div>

            {/* LGA Domestic Rates Table */}
            {lgaRateTab === 'domestic' && (
              <div>
                <h4 className='font-semibold mb-3 text-green-700'>Domestic LGA Rates (0.5kg - 10kg)</h4>
                {/* Filtered here rather than server-side, matching what the
                    table showed before: the state picker above narrows the list. */}
                <StandardRateTable
                  type="lga_domestic"
                  rows={(lgaDomesticRates || []).filter((r: any) => !selectedStateForLga || r.state_name === selectedStateForLga)}
                  onChanged={loadLgaRates}
                />
              </div>
            )}

            {/* LGA Bulk Rates Table */}
            {lgaRateTab === 'bulk' && (
              <div>
                <h4 className='font-semibold mb-3 text-green-700'>Bulk LGA Rates (20kg+)</h4>
                {/* Filtered here rather than server-side, matching what the
                    table showed before: the state picker above narrows the list. */}
                <StandardRateTable
                  type="lga_bulk"
                  rows={(lgaBulkRates || []).filter((r: any) => !selectedStateForLga || r.state_name === selectedStateForLga)}
                  onChanged={loadLgaRates}
                />
              </div>
            )}
          </div>
        )}
      </div>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  )
}

export default ManageRates